import { Grid, TextField, ThemeProvider, Typography } from "@mui/material";
import textFieldTheme from "./textfieldThemeProvider";

const InputField = ({ label, value, onChange, isRequired , rows, multiline,textVariant,...props}) => (
  <Grid item xs={12}>
    <Typography  variant={textVariant?textVariant:"body1"}>{label} {isRequired && <span style={{color:"red"}}>*</span> }</Typography>

    <ThemeProvider theme={textFieldTheme}>
      <TextField rows={rows} multiline={multiline} {...props} value={value} onChange={onChange}  />
    </ThemeProvider>
  </Grid>
);

export default InputField;